import styled, { css } from "styled-components";
import { colors, darkModeColors } from "../../consts";

const CheckboxDisabledStyles = css`
  pointer-events: none;
  opacity: 0.5;

  .checkbox--active {
    border-color: ${colors.RAISIN_10} !important;
    background: ${colors.RAISIN_10} !important;
  }
`;

export const CheckboxLabel = styled.div`
  ${(props) => props.disabled && CheckboxDisabledStyles};
  cursor: pointer;
  
  span {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    height: 24px;
    width: 24px;
    background: ${darkModeColors.WHITE_RAISIN_100};
    border: 1px solid ${colors.RAISIN_50};

    border-radius: 6px;
  }

  .checkbox--active {
    border-color: ${colors.TURQUOISE_100};
    background: ${colors.TURQUOISE_100};
  }
`;

export const CheckmarkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  opacity: ${(props) => (props?.checked || props?.partiallyChecked ? 1 : 0)};
`;
